import { UserAppPreferencesService } from 'api/services/UserAppPreferencesService'
import { IconButton } from 'blaze-ui/IconButton/IconButton'
import { ChevronDoubleLeft } from 'blaze-ui/icons'
import { observer } from 'mobx-react-lite'
import { useDispatch } from 'react-redux'
import { setFloatingSidebar } from 'redux/actions'
import { useRootStore } from 'stores/RootStore'
import Styles from './LockButton.module.scss'
import cx from 'classnames'
import { useIsSystemRedesign } from 'hooks/useIsSystemRedesign'

export const LockButton = observer(() => {
  const isSystemRedesignEnabled = useIsSystemRedesign()
  const rootStore = useRootStore()
  const dispatch = useDispatch()

  const handlePress = () => {
    rootStore.leftSidebarStore.setIsHovered(false)
    UserAppPreferencesService.unlockSidebar()
    dispatch(setFloatingSidebar(false))
  }

  return (
    <div className={cx(Styles.lockButtonContainer, { [Styles.visible]: rootStore.leftSidebarStore.isHovered })}>
      <IconButton
        icon={ChevronDoubleLeft}
        variant="tertiary"
        size={isSystemRedesignEnabled ? 'md' : 'lg'}
        onPress={handlePress}
        rounded
      />
    </div>
  )
})
